import { render, staticRenderFns } from "./SchedaValutazioneEsigenzeImmediateList.vue?vue&type=template&id=6cff6fce"
import script from "./SchedaValutazioneEsigenzeImmediateList.vue?vue&type=script&lang=js"
export * from "./SchedaValutazioneEsigenzeImmediateList.vue?vue&type=script&lang=js"
import style0 from "./SchedaValutazioneEsigenzeImmediateList.vue?vue&type=style&index=0&id=6cff6fce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports